import { Component, OnInit, OnDestroy, Input, AfterViewInit, Renderer2, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { TransferState, makeStateKey } from '@angular/core';
// ngrx store
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

// services
import { ErrorHandler } from '../../../services/error-handler.service';
import { FlightDetailsService } from '../../../services/flight-details.service';
import { UrlParamsService } from '../../../services/url-params.service';
import { AppStateService } from '../../../services/app-state.service';
import { AppLoaderService } from '../../../services/app-loader.service';
import { ExternalScriptsService } from '../../../services/external-scripts.service';
// models
import { AppState } from '../../../../booking/models/app-state.interface';
// external libs
import { REACT_QUOTE_FORM, BOOKINGPOD_GLOBAL_FNS } from '../../../globals';

const HAS_SESSION_KEY = makeStateKey('has_session');

@Component({
  selector: 'app-modal-flight-search',
  templateUrl: './modal-flight-search.component.html',
  styleUrls: ['./modal-flight-search.component.scss']
})
export class ModalFlightSearchComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  modalData;

  // private _quoteFlightDataSubscription: Subscription;
  // private _sessionParamsSubscription: Subscription;
  // private _paramDataSubscription: Subscription;
  // private _flightFinderSubscription: Subscription;

  private _reactComponentListener;
  private _flightResultCount = 0;
  private _formHasError = false;
  private _listenerAttached = false;
  private _oldRequest = false;
  private _userLanguageSubscription: Subscription;

  public selectedLanguage = '';
  public selectedLanguageCode = 'en';
  public loadAPI: Promise<any>;
  public submittedValue: any = {};
  // public hasSession = false;
  // public hasBeenRedirected = false;
  // public sessionUsed = false;
  public reactDataConfig = {
    'partner': 'none',
    'mobileDisplayOnly': true
  };
  public reactDataConfigString = '';

  constructor(
    private _appStore: Store<AppState>,
    private _renderer: Renderer2,
    private _flightDetailsService: FlightDetailsService,
    private _errorService: ErrorHandler,
    private _activatedRoute: ActivatedRoute,
    private _urlParamsService: UrlParamsService,
    private _appStateService: AppStateService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _appLoaderService: AppLoaderService,
    private _serverState: TransferState,
    private _externalScriptsService: ExternalScriptsService
  ) { }

  ngOnInit() {

    // if (isPlatformBrowser(this.platformId)) {
    //   ga('set', 'page', '/flight-finder/search');
    //   ga('send', 'pageview');
    // }

    this.reactDataConfig.partner = this.getState(this._appStore).partnerReducer.partnerName;
    this.reactDataConfigString = JSON.stringify(this.reactDataConfig);

    this._userLanguageSubscription = this._appStore.select('copyReducer')
      .subscribe((res: any) => {
        this.selectedLanguage = res.language;
        this.selectedLanguageCode = res.languageCode;
      })

    if (isPlatformServer(this.platformId)) {
      // // subscribe to router query string
      // this._sessionParamsSubscription = this._activatedRoute.queryParams
      //   .subscribe((params: any) => {
      //       if (typeof params.session !== 'undefined' || typeof params.returnSession !== 'undefined') {
      //         this.hasSession = true;
      //         this._serverState.set(HAS_SESSION_KEY, this.hasSession as any);
      //         // this._appLoaderService.showLoader(this.appLoaderSteps);
      //       } else {
      //         this.hasSession = false;
      //         this._serverState.set(HAS_SESSION_KEY, this.hasSession as any);
      //         // this._appLoaderService.hideLoader();
      //       }
      //   },
      //   err => console.log(err));

      // this._paramDataSubscription = this._urlParamsService.sessionParamsData$
      //   .subscribe(data => {

      //     if (data.error) {
      //       this._appStore.dispatch({ type: 'UPDATE_DATALINK_ERROR', payload: true });
      //       this.hasSession = false;
      //       this._serverState.set(HAS_SESSION_KEY, this.hasSession as any);
      //       this._appLoaderService.hideLoader();
      //     }

      //     if (data.flightConnections === null) {
      //       this.hasSession = false;
      //       this._serverState.set(HAS_SESSION_KEY, this.hasSession as any);
      //       this._appLoaderService.hideLoader();
      //     }
      //   });

      // this._flightFinderSubscription = this._appStore.select('flightFinderReducer')
      //   .subscribe((res: FlightFinderInitState) => {
      //     if (res.datalinkError) {
      //       this.hasSession = false;
      //       this._serverState.set(HAS_SESSION_KEY, this.hasSession as any);
      //       this._appLoaderService.hideLoader();
      //       this._appStore.dispatch({ type: 'UPDATE_DATALINK_ERROR', payload: false });
      //     }

      //   });

    } else {
      const options = {
        id: 'portr-booking-pod',
        src: REACT_QUOTE_FORM
      };
      this._externalScriptsService.loadScript(options);
      this._externalScriptsService.loadScript({
        id: 'pod-global-fns',
        src: BOOKINGPOD_GLOBAL_FNS
      });
      this._appStore.dispatch({ type: 'UPDATE_API_SEARCH', payload: false });

      // this.hasSession = this._serverState.get(HAS_SESSION_KEY, null as any);
      // this.hasBeenRedirected = this.getState(this._appStore).flightFinderReducer.redirectToSearch;
      // this.sessionUsed = this.getState(this._appStore).flightFinderReducer.sessionUsed;

      // if (!this.hasSession || this.hasBeenRedirected || this.sessionUsed) {

      //   const cleanUri = location.protocol + '//' + location.host + location.pathname;
      //   window.history.replaceState({}, document.title, cleanUri);

      //   this.loadAPI = new Promise((resolve) => {
      //     this.loadScript();
      //     resolve(true);
      //   });
      // } else if (this.hasSession && !this.sessionUsed) {
      //   this._appLoaderService.showLoader();
      // } else { }

      // // this._appStore.dispatch({ type: 'UPDATE_API_SEARCH', payload: false });
      // this._appStore.dispatch({ type: 'UPDATE_FILTER_LEGS', payload: {
      //   direct: true,
      //   oneStop: false,
      //   twoStop: false
      // } });

      // this._flightFinderSubscription = this._appStore.select('flightFinderReducer')
      //   .subscribe((res: FlightFinderInitState) => {

      //     if (res.datalinkError) {
      //       this.hasSession = false;
      //       this.sessionUsed = true;
      //       this._appLoaderService.hideLoader();
      //       this._appStore.dispatch({ type: 'UPDATE_DATALINK_ERROR', payload: false });
      //       this.loadAPI = new Promise((resolve) => {
      //         this.loadScript();
      //         resolve(true);
      //       });
      //     }

      //   });

    }

  }

  ngAfterViewInit() {
    // listen to global change event from react component
    // if (!this.hasSession || this.hasBeenRedirected || this.sessionUsed) {
    //   // attach change event to react data passed into input
    //   if (isPlatformBrowser(this.platformId)) {
    //     this._appLoaderService.hideLoader();
    //     this.attachListener();
    //   }
    // }
    this.attachListener();
    this.checkStoreForRequest();
  }

  attachListener() {

    // if listener already attched
    // return
    if (this._listenerAttached) { return; }

    this._listenerAttached = true;

    // attach listener to change of hidden input
    const submittedInput = document.getElementById('quote-submitted-data');

    this._reactComponentListener = this._renderer.listen(submittedInput, 'change', () => {
      if (!this._formHasError && !this._oldRequest) {
        const stringVal = (<HTMLInputElement>document.getElementById('quote-submitted-data')).value;
        this.submittedValue = JSON.parse(stringVal);

        // if (this.submittedValue.showLoader) {
        //   // console.log(1);
        //   this.hasSession = true;
        //   // this._appLoaderService.showLoader(this.appLoaderSteps);
        // }

        this._appStore.dispatch({
          type: 'UPDATE_FILTER_LEGS', payload: {
            direct: true,
            oneStop: false,
            twoStop: false
          }
        });

        this._appStore.dispatch({ type: 'UPDATE_PAGINATION_DATA', payload: null });
        this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_CACHE_REQUEST', payload: null });
        this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_DATA', payload: this.submittedValue });
        this._appStore.dispatch({ type: 'UPDATE_OPTED_IN_VIA_BANNER', payload: this.submittedValue.optedInViaPod });
        this._appStore.dispatch({ type: 'UPDATE_PRODUCT_TIER_FROM_URL', payload: this.submittedValue.productTier });
        this._appStore.dispatch({ type: 'INCREMENT_REQUEST_COUNT' });

        this.close(null);
      }
    });
  }

  dispatchChangeEvent() {
    const node = document.getElementById('quote-submitted-data');
    const event = document.createEvent('Event');
    // args: string type, boolean bubbles, boolean cancelable
    event.initEvent('change', true, true);
    node.dispatchEvent(event);
    this._formHasError = false;
    this._oldRequest = false;
  }

  checkStoreForRequest() {
    const storedRequest = this.getState(this._appStore).flightFinderReducer;
    if (!this.checkForNull(storedRequest.quoteFlightRequest)) {
      this._oldRequest = true;
      const dataToPassBack: any = storedRequest.quoteFlightRequest;
      this._renderer.setProperty(document.getElementById('quote-submitted-data'), 'value', JSON.stringify(dataToPassBack));
      if (isPlatformBrowser(this.platformId)) {
        this.dispatchChangeEvent();
      }
      this._oldRequest = false;
    }
  }

  checkForNull(obj) {
    for (const item in obj) {
      if (obj[item] === null && item !== 'productTier' && item !== 'airlineProduct' && item !== 'flightNumber') {
        return true;
      }
    }
    return false;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  close(event) {
    this._errorService.modalItem$.next('remove');
  }

  ngOnDestroy() {


    if (this._reactComponentListener) {
      this._reactComponentListener();
    }

    if (isPlatformBrowser(this.platformId)) {

      // this._flightFinderSubscription.unsubscribe();

      this._externalScriptsService.removeScript('portr-booking-pod');
      this._externalScriptsService.removeScript('pod-global-fns');
      this._externalScriptsService.podUiCleanup('bookingPod');
      this._renderer.setStyle(document.body, 'position', 'sticky');
    }

    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }

    this._appStore.dispatch({ type: 'UPDATE_REDIRECT_TO_SEARCH', payload: false });
    // this.hasSession = false;
  }

}

